/**
 * @class FJCanvasManager
 * @classdesc Canvas标签池
 */
let FJCanvasManager = (function () {
  let canvases = [];
  return {

    /**
     * @description 获取闲置的画布标签
     * @return {element}
     */
    getCanvas: function () {
      let canvas = canvases.find(v => v.idle);
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvases.push(canvas);
      }
      canvas.idle = false;

      return canvas;
    },

    /**
     * @description 视频视频标签
     * @param {element} canvas
     */
    releaseCanvas: function (canvas) {
      if (!canvas) {
        return;
      }
      canvas.width = 1;
      canvas.height = 1;
      canvas.idle = true;
    },

    /**
     * @description 打印使用情况
     */
    logInfo: function () {
      let idleCanvases = canvases.filter(canvas => canvas.idle);
      console.log(`%cAll canvas' count: ${canvases.length}, idle canvas' count: ${idleCanvases.length}`, 'background: gray')
    }
  }
})();

export default FJCanvasManager;
